import {Directive, Input, ElementRef, OnInit, OnChanges, SimpleChanges} from '@angular/core';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[bigImage]'
})
export class ImageZoomDirective implements OnInit, OnChanges{
  @Input('bigImage') imgUrl: string;
  img: any;
  constructor(public element: ElementRef) {
  }

  run(url) {
    if (!url) {
      return;
    }
    let el = this.element.nativeElement;

    this.img = document.createElement('img');
    this.img.setAttribute('src', url);
    $(el).after($(this.img));

    this.img.style['display'] = 'none';
    this.img.style['left'] = '0px';
    this.img.style['margin-left'] = '220px';
    this.img.style['margin-top'] = '-110px';
    this.img.style['height'] = '300px';
    this.img.style['opacity'] = '0.9';
    this.img.style['position'] = 'absolute';
    this.img.style['z-index'] = '9999';

    el.addEventListener("mouseover", () => {
      const height = window.innerHeight - 62;
      const viewportOffset = el.getBoundingClientRect();
      const percentage = viewportOffset.top / height * 100;
      this.img.style['display'] = 'block';
      if (percentage > 50) {
        this.img.style['margin-top'] = '-300px';
      } else {
        this.img.style['margin-top'] = '-110px';
      }
    });

    el.addEventListener("mouseout", () => {
      this.img.style['display'] = 'none';
    });
  }

  ngOnInit(): void {
    this.run(this.imgUrl);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['imageUrl']) {
      if (!this.img) {
        this.run(changes['imageUrl'].currentValue);
      } else {
        this.img.setAttribute('src', changes['imageUrl'].currentValue);
      }
    }
  }

}
